import { useTestingLabSelectTestingLabsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useOptions } from '../../hooks/useOptions'
import { toLabeledValues } from '../../utils/labeledValues'
import { TestingLabSelectContext } from './types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<TestingLabSelectContext>(
  'TestingLabSelectContext'
)

export const useTestingLabSelectContext = useContextFn

const TestingLabSelectProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading } = useTestingLabSelectTestingLabsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const options = useOptions({
    items: data?.testingLabs?.records,
    label: 'name',
    value: 'id',
    sort: 'name',
  })
  return (
    <Provider
      value={{
        options,
        loading,
        fromLabeledValue: (value) => value?.value as number,
        fromLabeledValues: (values) =>
          (values ?? []).map(({ value }) => value as number),
        toLabeledValue: (lab) =>
          lab ? { label: lab.name, value: lab.id } : undefined,
        toLabeledValues: (records) =>
          toLabeledValues(records, { label: 'name', value: 'id' }),
      }}
    >
      {children}
    </Provider>
  )
}

export default TestingLabSelectProvider
